import { render, staticRenderFns } from "./CourseCardSuggest.vue?vue&type=template&id=7212e2c4&scoped=true"
import script from "./CourseCardSuggest.vue?vue&type=script&lang=js"
export * from "./CourseCardSuggest.vue?vue&type=script&lang=js"
import style0 from "./CourseCardSuggest.vue?vue&type=style&index=0&id=7212e2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7212e2c4",
  null
  
)

export default component.exports